<template>
	<span>
		<div id="suspend-btn" class="suspend-btn"  ref="suspendButton" v-if="zhShow"
			:style="{'left': left+'px','top': top+'px'}"    
			@touchstart.prevent="(e) => {dragStart(e)}"     
			@touchend.prevent="(e) => {dragEnd(e)}"     
			@touchmove.prevent="(e) => {dragProgress(e)}" >  

			更 新
		</div>
		<div class="freshBtn"  ref="suspendButton" v-else
			@touchstart.prevent="(e) => {dragStart(e)}"
			@touchend.prevent="(e) => {dragEnd(e)}"     
			@touchmove.prevent="(e) => {dragProgress(e)}" 
		>
		  <img src="@/assets/home/14.png">
		</div>
	</span>
</template>
<script>
export default {
    name: 'SuspendButton',
    props:{
		zhShow:{
			type:Boolean,
			default:false
		}
	},
    data () {
        return {
            gapWidth: 10,
            itemWidth: 30, // 图标的宽度
            itemHeight: 30, // 图标的高度
            clientWidth:0,
            clientHeight:0, 
            left: 0,
            top: 0,

            startTime: 0,
            endTime: 0,
        }
    },
    created() {      
        this.clientWidth = document.documentElement.clientWidth;     
        this.clientHeight = document.documentElement.clientHeight;      
        this.left = this.clientWidth - this.itemWidth - this.gapWidth;      
        this.top = this.clientHeight * 0.2;   
    },
     
    methods: {    
        dragStart(e) {        
            this.$refs.suspendButton.style.transition = 'none';
            this.startTime = new Date();
        },
        dragEnd(e) { 
            this.endTime = new Date();                
            if(this.endTime - this.startTime < 150){
                this.$emit("suspendFn", true);
            }

            this.$refs.suspendButton.style.transition = 'all 0.3s';        
            if (this.left > this.clientWidth/2) {          
                this.left = this.clientWidth - this.itemWidth - this.gapWidth;
            } else {          
                this.left = this.gapWidth;        
            }  

            if(this.top < 0){
                this.top = this.itemWidth;
            }

            if(this.top > this.clientHeight - this.itemWidth){
                this.top = this.clientHeight - this.itemWidth - this.gapWidth;
            }

            
        },      
        dragProgress(e) {        
            if (e.targetTouches.length === 1) {          
                let touch = event.targetTouches[0];          
                this.left = touch.clientX - this.itemWidth/2;              
                this.top = touch.clientY - this.itemHeight/2;        
            }      
        },
    },
}
</script>
<style lang="less" scoped>
    .suspend-btn{
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: 30px;
        height: 30px;
        color: #fff;
        font-size: 10px;
        border-radius: 15px;
        background: #7fbdfb;
        box-shadow: 0 0px 15px #005ab5 inset;
    }

    .suspend-btn::before{
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background: inherit;
        border-radius: inherit;
        animation: wave 2s ease-out infinite;
    }

    @keyframes wave {
      50%,
      75% {
        transform: scale(1.5);
      }

      80%,
      100% {
        opacity: 0;
      }
    }
</style>
